module.exports = __webpack_public_path__ + "static/media/top-text.79523ce9.png";